import { AuthState } from "../types";

const state: AuthState = {
  token: "",
  verifyEmail: "",
  refreshToken: "",
  expires: "",
  isAuthenticated: false,
  user: {
    firstName: "",
    lastName: "",
  },
};

export default state;
